
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import StateButton from '@/components/inputs/StateButton.vue';

import userx from '@/store/modules/userx';
import schemax from '@/store/modules/schemax';
import schemaz from '@/store/schemaz';
import progressToastx from '@/store/modules/progressToastx';

import {
	SoftwareType,
	SchemaDic,
	SchemaData,
	ExtractorItem,
	TableSchema,
	EditState,
} from '@/store/models.def';
import TableSchemaComponent from './TableSchema.vue';
import uuid from 'uuid';

@Component({
	components: {
		TableSchemaComponent,
		StateButton,
	},
})
export default class SchemaProfile extends Vue {

	public get tables(): Array<{ table: TableSchema; id: string }> {
		if (!this.parsedModel) {
			return [];
		}
		return this.parsedModel.map((table) => {
			return { id: table.id, table };
		});
		return [];
	}

	public get availableSchemas(): Array<string | { value: any; text: string }> {
		const schemas = schemax.groupedSchemas;
		if (!this.softwareType || !schemas) {
			return [];
		}
		return schemas[this.softwareType].reduce(
			(options, data) => {
				if (data.id !== this.id && !schemaz.isAHasBAsParentSchema(data, this.data!)) {
					options.push(data.id);
				}
				return options;
			},
			[{ value: null, text: 'null' }] as Array<
				string | { value: any; text: string }
			>,
		);
	}

	public get id() {
		return this.data && this.data.id;
	}
	public get softwareType() {
		return this.data && this.data.softwareType;
	}

	public get parentSchema() {
		if (!this.parentId || this.parentId === this.id) {
			return null;
		}
		return schemax.allSchemas.find((sm) => sm.id === this.parentId);
	}
	public get parentSolution() {
		return this.parentSchema && this.parentSchema.parsedSolution;
	}

	public get supportLvl() {
		return userx.user && userx.user.supportLvl;
	}

	public get updateSchemaLabel() {
		const labels = {
			active: 'Update Schema',
			sending: 'Updating...',
			done: 'Updated Schema',
		};
		return labels[this.updateSchemaState];
	}
	@Prop({ default: null }) public value!: SchemaData | null;

	public updateSchemaState: EditState = 'active';
	public parentId: string | null = null;
	public parsedModel?: TableSchema[] | null = [];

	public data: SchemaData | null = null;

	@Watch('value')
	public onValueChanged(val: SchemaData, oldVal: SchemaData) {
		if (val !== null) {
			this.data = val;
			this.parentId = val.parentId;
			if (JSON.stringify(this.parsedModel) !== JSON.stringify(val.parsedModel)) {
				this.parsedModel = val.parsedModel;
			}
			const result = this._validfy();
			if (result === null) {
				this.$emit('input', null);
			}
		}
	}
	public mounted() {
		let result = null;
		if (this.value) {
			this.data = this.value;
			this.parentId = this.data.parentId;
			this.parsedModel = this.data.parsedModel;
			result = this._validfy();
		}
		if (result === null) {
			this.$emit('input', null);
		}
	}
	public addTable() {
		this.parsedModel = [
			...(this.parsedModel || []),
			{
				id: uuid.v4(),
				table: '',
				collection: '',
				keyField: '',
				type: this.parentId ? 'inherit' : 'master',
				masterKey: '',
				detailPath: '',
				extractor: {},
			},
		];
		this._onInput();
	}
	public removeTable(id: string) {
		this.parsedModel = this.parsedModel!.filter((table) => table.id !== id);
		this._onInput();
	}
	public async updateSchema() {
		if (this.updateSchemaState !== 'active') {
			return;
		}
		if (!this.value) {
			return;
		}
		const toastId = await progressToastx.add({
			title: `${this.id}`,
			state: `Updating schema...`,
			variant: 'info',
		});
		this.updateSchemaState = 'sending';
		const result = await schemax.updateSchema(this.value);
		this.updateSchemaState = 'active';
		console.log('updateSchema', result);
		if (result.success) {
			progressToastx.done({ id: toastId, state: `Schema updated!` });
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
	protected _onInput() {
		this.$emit('input', this._validfy());
	}
	protected _validfy() {
		if (this.parentId === this.id) {
			this.parentId = null;
		}

		for (const table of this.tables) {
			if (table.table === null) {
				return null;
			}
		}

		const parsedModel = JSON.parse(JSON.stringify(this.parsedModel));
		const parentId = this.parentId;

		return { ...this.data, parsedModel, parentId };
	}
}
